import {CUSTOM_FILTER, FilterBlock, FilterField, FilterValue, Operator} from '../models/filter';
import {ResearchPaperDTO, ResearchSource} from '../dto/research-paper';
import {paperAuditedScreening, paperCompleteManuelOverride, paperPassedScreening} from './research-paper';


export function createFilterBlocks(selectedFilter: string[]): FilterBlock[] {
  const screeningFilter1 = selectedFilter.includes(CUSTOM_FILTER.TITLE_ABSTRACT_SCREENING_AUDITED);
  const screeningFilter2 = selectedFilter.includes(CUSTOM_FILTER.FULL_TEXT_SCREENING_AUDITED);
  const screeningFilter1Passed = selectedFilter.includes(CUSTOM_FILTER.TITLE_ABSTRACT_SCREENING_PASSED);
  const screeningFilter2Passed = selectedFilter.includes(CUSTOM_FILTER.FULL_TEXT_SCREENING_PASSED);
  const pdfFilter = selectedFilter.includes(CUSTOM_FILTER.PDF_DOWNLOADED);
  const manuelFilter = selectedFilter.includes(CUSTOM_FILTER.MANUAL_ACCEPTED);
  const manuelOverwrittenFilter = selectedFilter.includes(CUSTOM_FILTER.MANUAL_OVERWRITTEN);

  let filters = [];

  if (screeningFilter1) {
    filters.push({
      filter: FilterField.TITLE_ABSTRACT_SCREENING,
      operator: Operator.IS,
      value: FilterValue.AUDITED,
      possibleOperators: [],
      possibleValues: [],
    });
  }
  if (screeningFilter2) {
    filters.push({
      filter: FilterField.FULL_TEXT_SCREENING,
      operator: Operator.IS,
      value: FilterValue.AUDITED,
      possibleOperators: [],
      possibleValues: [],
    });
  }
  if (screeningFilter1Passed) {
    filters.push({
      filter: FilterField.TITLE_ABSTRACT_SCREENING,
      operator: Operator.IS,
      value: FilterValue.PASSED,
      possibleOperators: [],
      possibleValues: [],
    });
  }
  if (screeningFilter2Passed) {
    filters.push({
      filter: FilterField.FULL_TEXT_SCREENING,
      operator: Operator.IS,
      value: FilterValue.PASSED,
      possibleOperators: [],
      possibleValues: [],
    });
  }
  if (pdfFilter) {
    filters.push({
      filter: FilterField.PDF_AVAILABLE,
      operator: Operator.YES,
      value: '',
      possibleOperators: [],
      possibleValues: [],
    });
  }
  if (manuelFilter) {
    filters.push({
      filter: FilterField.MANUEL,
      operator: Operator.IS,
      value: FilterValue.ACCEPTED,
      possibleOperators: [],
      possibleValues: [],
    });
  }
  if (manuelOverwrittenFilter) {
    filters.push({
      filter: FilterField.MANUEL,
      operator: Operator.IS,
      value: FilterValue.OVERWRITTEN,
      possibleOperators: [],
      possibleValues: [],
    });
  }
  return filters;
}

export function filterPaper(paper: ResearchPaperDTO, filter: FilterBlock): boolean {
  if (!filter.operator) {
    return true;
  }
  const operator = filter.operator;
  const value = filter.value;
  switch (filter.filter) {
    case FilterField.FULL_TEXT_SCREENING:
      if (value === FilterValue.PASSED) {
        const passed = paperPassedScreening(paper, true);
        return operator === Operator.IS ? passed === true : passed === false;
      }
      if (value?.includes(FilterValue.PASSED)) {
        return checkPassedForResult(paper, value, true);
      }
      const auditTwo = paperAuditedScreening(paper, true);
      return operator === Operator.IS ? auditTwo === true : auditTwo === false;
    case FilterField.PDF_AVAILABLE:
      if (operator === Operator.YES) {
        return paper.hasDownloadedPdf === true;
      }
      return paper.hasDownloadedPdf === false;
    case FilterField.SELF_CREATED:
      if (operator === Operator.YES) {
        return paper.source === ResearchSource.SELF_CREATED;
      }
      return paper.source !== ResearchSource.SELF_CREATED
    case FilterField.TITLE_ABSTRACT_SCREENING:
      if (value === FilterValue.PASSED) {
        const passed = paperPassedScreening(paper);
        return operator === Operator.IS ? passed === true : passed === false;
      }
      if (value?.includes(FilterValue.PASSED)) {
        return checkPassedForResult(paper, value, true);
      }
      const auditOne = paperAuditedScreening(paper);
      return operator === Operator.IS ? auditOne === true : auditOne === false;
    case FilterField.MANUEL:
      if (value === FilterValue.OVERWRITTEN) {
        const manuel = paperCompleteManuelOverride(paper);
        return operator === Operator.IS ? manuel : !manuel;
      }
      const manuel = paperCompleteManuelOverride(paper);
      return operator === Operator.IS ? manuel : !manuel;
    case FilterField.PROPERTY:
      return filterPapersProperty(paper, filter);
  }
  return true;
}

function checkPassedForResult(paper: ResearchPaperDTO, value: string, screeningOne: boolean): boolean {
  if (!paper.latestScreeningRun) {
    return false;
  }
  if (screeningOne && !paper.latestScreeningRun.screeningOne) {
    return false;
  }
  if (!screeningOne && !paper.latestScreeningRun.screeningTwo) {
    return false;
  }
  const result = screeningOne ? paper.latestScreeningRun.screeningOne! : paper.latestScreeningRun.screeningTwo!;
  const prop = value.replace(FilterValue.PASSED + ' ', '');
  const found = result.result.filter(r => r.criteria === prop);
  if (found.length === 0) {
    return false;
  }
  return found[0].passed;
}

function filterPapersProperty(paper: ResearchPaperDTO, filter: FilterBlock): boolean {
  if (!filter.operator || !filter.value) {
    return true;
  }
  const isSet = filter.operator === Operator.IS_SET;
  const value = filter.value;
  if (isSet) {
    return (paper as any)[value] !== null;
  }
  return (paper as any)[value] === null;
}
